import { getElements } from '../Utility/Dom'

class NavAdditional {
  private readonly buttons: NodeListOf<HTMLElement>

  constructor() {
    this.buttons = getElements('nav-additional-button')
  }

  public init(): void {
    if (this.buttons.length === 0) return

    this.addEvents()
  }

  private addEvents(): void {
    this.buttons.forEach((button): void => {
      button.addEventListener('click', (): void => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true'
        button.setAttribute('aria-expanded', (!isExpanded).toString())
      })
    })
  }
}

const navAdditional = new NavAdditional()
navAdditional.init()
